import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IPolicy } from '@verzekeringapp-mono/shared/src/models/policy'
import { determinePolicyDistinctionLabel } from '@verzekeringapp-mono/shared/src/utils/policy_utils'
import React from 'react'
import { Link } from 'react-router-dom'

const ValueMeterLink = ({ policy }: { policy: IPolicy }) => (
  <Link
    key={policy.id}
    className='flex flex-col break-words rounded-md border border-border-subtle bg-surface-card p-6 text-center text-text-primary'
    to={`/dossier/waardemeters/${
      policy.productName === 'Woonhuis'
        ? 'herbouwwaardemeter'
        : 'inboedelwaardemeter'
    }/${policy.id}`}
  >
    <div className='mx-auto mb-4 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-surface-brand-subtle text-icon-brand'>
      {policy?.productName === 'Inboedel'
        ? (
          <FontAwesomeIcon
            icon={['fas', 'couch']}
            className='text-icon-brand'
          />
        )
        : (
          <FontAwesomeIcon
            icon={['fas', 'home']}
            className='text-icon-brand'
          />
        )}
    </div>

    <h3 className='mb-2'>
      {policy.productName === 'Woonhuis'
        ? 'Herbouwwaardemeter'
        : 'Inboedelwaardemeter'}

      <br />
    </h3>

    <p className='text-sm text-text-secondary'>
      (
      {determinePolicyDistinctionLabel({
        details: policy.details,
        productId: policy.productId,
        policyNumber: policy.policyNumber
      })}
      )
    </p>
  </Link>
)

export default ValueMeterLink
